import {z} from 'zod';

import {dbRoleToLocalRole} from '../../functions/convertUserRole';
import {DbUserRole, UserStatus} from '../../types/enums';

import type {UserRole} from '../../types/enums';

export const whoamiSchema = z.object({
  id: z.string(),
  companyId: z.string(),
  name: z.string(),
  email: z.email(),
  phoneNumber: z.string(),
  thumbnail: z.string(),
  created: z.coerce.date(),
  modified: z.coerce.date(),
  roleId: z.enum(DbUserRole).transform<UserRole>(dbRoleToLocalRole),
  status: z.enum(UserStatus),

  permissions: z
    .object({
      reports: z.boolean(),
      downloads: z.boolean(),
      presentations: z.boolean().catch(false),
    })
    .nullable(),
});
